import { render } from "./ExpiredSubscription.vue?vue&type=template&id=1eb08296&scoped=true"
import script from "./ExpiredSubscription.vue?vue&type=script&lang=js"
export * from "./ExpiredSubscription.vue?vue&type=script&lang=js"

import "./ExpiredSubscription.vue?vue&type=style&index=0&id=1eb08296&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb08296"]])

export default __exports__